var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefrenceDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1519 12.6592C24.1519 8.66384 20.9016 5.41357 16.9063 5.41357C12.9109 5.41357 9.66064 8.66384 9.66064 12.6592C9.66064 16.6545 12.9109 19.9048 16.9063 19.9048C20.9016 19.9048 24.1519 16.6545 24.1519 12.6592ZM14.4911 16.8858H12.0759C11.7419 16.8858 11.472 16.6159 11.472 16.282V10.244C11.472 9.91008 11.7419 9.64018 12.0759 9.64018H14.4911C14.7489 9.64018 14.965 9.80321 15.052 10.0302C15.4614 9.60275 15.6987 9.02491 15.6987 8.43258C15.6987 7.43389 16.5114 6.62118 17.5101 6.62118C18.5087 6.62118 19.3215 7.43389 19.3215 8.43258V9.64018H20.5291C21.5278 9.64018 22.3405 10.4529 22.3405 11.4516V14.4706C22.3405 15.4693 21.5278 16.282 20.5291 16.282H15.0949C15.0949 16.6159 14.825 16.8858 14.4911 16.8858Z",
    fill: "#8D90A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1327 14.4709V11.4519C21.1327 11.1186 20.8622 10.8481 20.5289 10.8481H18.7175C18.3836 10.8481 18.1137 10.5782 18.1137 10.2443V8.4329C18.1137 8.0996 17.8432 7.8291 17.5099 7.8291C17.1766 7.8291 16.9061 8.0996 16.9061 8.4329C16.9061 9.35913 16.5306 10.266 15.8754 10.9212L15.0947 11.7019V15.0747H20.5289C20.8622 15.0747 21.1327 14.8042 21.1327 14.4709Z",
    fill: "#8D90A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8873 10.8477H12.6797V15.6781H13.8873V10.8477Z",
    fill: "#8D90A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3979 10.4727V13.639L33.4334 12.0558L31.3979 10.4727Z",
    fill: "#8D90A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6981 0.594292C17.6783 -0.197896 16.1362 -0.1985 15.1145 0.594895L13.5767 1.79103H20.2372L18.6981 0.594292Z",
    fill: "#8D90A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4153 10.4727L0.379883 12.0558L2.4153 13.639V10.4727Z",
    fill: "#8D90A5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.29V34.3687L13.5499 23.8294L0 13.29Z",
    fill: "#8D90A5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2645 23.0767L30.1903 14.5782V2.99854H3.62305V14.5782L14.5488 23.0767C15.9321 22.1203 17.8824 22.1209 19.2645 23.0767ZM8.45346 12.6594C8.45346 7.99801 12.2453 4.20614 16.9067 4.20614C21.568 4.20614 25.3599 7.99801 25.3599 12.6594C25.3599 17.3207 21.568 21.1126 16.9067 21.1126C12.2453 21.1126 8.45346 17.3207 8.45346 12.6594Z",
    fill: "#8D90A5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1144 24.1427L1.15576 34.9997H32.6567L18.698 24.1421C17.6776 23.3493 16.1361 23.3487 15.1144 24.1427Z",
    fill: "#8D90A5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2632 23.8294L33.8131 34.3687V13.29L20.2632 23.8294Z",
    fill: "#8D90A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrenceDocumentIcon);
export default __webpack_public_path__ + "static/media/refrenceDocumentIcon.312aa22e7a6d6c4b675578194e40384d.svg";
export { ForwardRef as ReactComponent };